import { render } from "./CreateAccount.vue?vue&type=template&id=2772a97b&scoped=true&ts=true"
import script from "./CreateAccount.vue?vue&type=script&lang=ts"
export * from "./CreateAccount.vue?vue&type=script&lang=ts"

import "./CreateAccount.vue?vue&type=style&index=0&id=2772a97b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2772a97b"]])

export default __exports__